export function getPlacement({ variant }) {
    if (variant === 'before') {
        return 'bottom-start';
    }
    if (variant === 'after') {
        return 'bottom-end';
    }
}
